import { useState } from 'react'
import TutorialV2Board from '../TutorialV2Board'
import { TUTORIAL_V3 } from '../../config/tutorialV3Steps'
import * as data from '../../data/prototypeData'
import { usePrototype } from './PrototypeContext'
import ChestReveal from './ChestReveal'
import './prototype.css'

// The progression prototype's tutorial: the scripted first war (Tutorial v3,
// config/tutorialV3*.js) on the tutorial board, then the Genesis Chest
// opening (genesisOpen, shown by ChestReveal), then the Hive with the Lumber
// Mill prompt. Leaving early goes home, where the tutorial waits to be played
// again.

// Development only: ?tutorialStep=<step id> opens the tutorial on that step.
const START_AT = process.env.NODE_ENV === 'development'
    ? new URLSearchParams(window.location.search).get('tutorialStep')
    : null

export default function TutorialScreen() {
    const { goHome, setScreen, setNotice } = usePrototype()
    // The chest screen comes up at once, wobbling until the receipt arrives.
    const [opening, setOpening] = useState(false)
    const [chest, setChest] = useState(null)

    const openChest = async () => {
        if (opening) return
        setOpening(true)
        try {
            const { receipt } = await data.openGenesisChest()
            setChest(receipt)
        } catch (e) {
            setNotice(e.message)
            goHome()
        }
    }

    if (opening) {
        return <ChestReveal receipt={chest} doneLabel="Place on Hive" onDone={() => setScreen({ name: 'hive', firstMill: true })} />
    }

    return (
        <main>
            <div className="centered">
                <TutorialV2Board tutorial={TUTORIAL_V3} onComplete={openChest} onExit={goHome} startAt={START_AT} />
            </div>
        </main>
    )
}
